import { mapDTO } from '@twistezo/ts-dto-mapper'
import { isNil } from 'lodash'

import { GamSetupOrderDTO } from '../api/types/gamSetupOrderDTO'
import { GamSetupOrder } from '../types/gamSetupOrder'

type From = GamSetupOrderDTO
type To = GamSetupOrder

export const gamSetupOrderFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    (dto: From): To => ({
      ...commonGamSetupOrderFromDTO(dto),
      createdAt: new Date(dto.createdAt),
    }),
  )

type CommonFrom = Omit<From, 'createdAt'>
type CommonTo = Omit<To, 'createdAt'>

export const commonGamSetupOrderFromDTO = (from: CommonFrom): CommonTo =>
  mapDTO<CommonFrom, CommonTo>({ from }).transform(
    (dto: CommonFrom): CommonTo => ({
      ...dto,
      bannerTemplateId: isNil(dto.bannerTemplateId) ? '' : String(dto.bannerTemplateId),
      duration: dto.duration / 1000,
      errorMessage: dto.errorMessage || undefined,
      nativeTemplateId: isNil(dto.nativeTemplateId) ? '' : String(dto.nativeTemplateId),
      updatedAt: new Date(dto.updatedAt),
      vastUrl: dto.vastUrl,
    }),
  )
